<template>
    <div>
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="我的请购单" name="1">
                <GoodsRequest v-if="activeName === '1'" />
            </el-tab-pane>
            <el-tab-pane label="请购单审批" name="2" v-if="canApprove">
                <GoodsRequestApproval v-if="activeName === '2'" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import GoodsRequest from './components/GoodsRequest.vue';
import GoodsRequestApproval from './components/GoodsRequestApproval.vue';
import { canApproveRequest } from "@/views/goods/permission.js";
export default {
   data() {
      return {
        activeName: '1', // 当前tab
        canApprove: canApproveRequest(), // 请购单审批权限（部门负责人组/总经理/CTO/事业部总监）
      }
   },
   created(){
   },
   components:{
      GoodsRequest,
      GoodsRequestApproval,
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="scss" scoped>

</style>
